<template>
  <section class="customer-quotes-section">
    <h3>{{ $t('customer.quotes') }}</h3>
    <home-customer-quotes-carousel />
  </section>
</template>

<script>
import HomeCustomerQuotesCarousel from '@/components/home/HomeCustomerQuotesCarousel.vue';

export default {
  components: {
    HomeCustomerQuotesCarousel,
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

.customer-quotes-section {
  margin-bottom: 150px;
}

h3 {
  margin-bottom: 40px;
  text-align: center;
}

@media (max-width: $page-laptop-breakpoint) {
  .customer-quotes-section {
    margin-bottom: 75px;
  }
}

@media (max-width: $page-mobile-large-breakpoint) {
  .customer-quotes-section {
    margin-bottom: 50px;
  }
}
</style>
